import { render } from "./HowToWear.vue?vue&type=template&id=5aea9220&scoped=true"
import script from "./HowToWear.vue?vue&type=script&lang=js"
export * from "./HowToWear.vue?vue&type=script&lang=js"

import "./HowToWear.vue?vue&type=style&index=0&id=5aea9220&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aea9220"]])

export default __exports__